import React from "react";

// Gas-cylinder (propane tank) icon — tall cylinder with a valve cap on top.
// Matches lucide-react visual style: 24x24 viewBox, 2px stroke, rounded joins.
export default function GasCylinderIcon({ size = 16, className = "", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {/* Valve stem on top */}
      <path d="M10 2h4v2h-4z" />
      {/* Collar ring */}
      <path d="M8 4h8v2H8z" />
      {/* Cylinder body */}
      <path d="M6 10a6 6 0 0 1 12 0v8a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3z" />
      {/* Horizontal band for visual interest */}
      <line x1="6.5" y1="14" x2="17.5" y2="14" />
    </svg>
  );
}
